import { useAuthSession } from "./auth.session.admin";
import { ConnectProto } from "@racoon/api";

export function useCurrentUser(): ConnectProto.User | undefined {
  const { user } = useAuthSession();
  return user as any;
}
